module.exports = __webpack_public_path__ + "static/media/Fling (janett).185abb95.mp3";